<!-- Loading Screen -->

@if (isReportSending) {
  <div class="wrapper center"
    >
    <div class="inner">
      <mat-spinner> </mat-spinner>
    </div>
  </div>
}

<!-- Pause Fishing Report-->

@if (!isReportSending) {
  <div class="container report-container"
    >
    <div class="container"
      style="padding-top: 20px;">
      <div class="row"
        align="center">
        @if (currPage <= numPages) {
          <h6 i18n>
        <small class="text-muted">
          Page {{currPage}} of {{numPages}}
        </small>
      </h6>
        }
        @if (currPage > numPages) {
          <h6 i18n>
        <small class="text-muted">
          Pause Fishing Report
        </small>
      </h6>
        }
      </div>
      <div class="row" align="center">
        <div class="col" style="display: flex; justify-content: space-between;">
          <mat-icon></mat-icon>
          @if (currPage <= numPages) {
            <mat-spinner
              mode="determinate"
              [diameter]="50"
              [strokeWidth]="6"
            [value]="spinnerProgress"></mat-spinner>
          }
          @if (currPage > numPages && !isComplete) {
            <mat-icon
              style="color: #3ebfb9">
              check_circle_outline
            </mat-icon>
          }
          @if (!isComplete) {
            <button mat-mini-fab matTooltip="Delete Report" style="background-color: #005d87;" (click)="deleteReport()">
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>
    <form [formGroup]="pauseForm">
      <!-- Choose date and enter area to start fishing -->
      @if (currPage === 1) {
        <div
          class="container details">
          <div class="row" align="center">
            <h5 i18n class="blue-heading-title">
          What day is this pause report for?
        </h5>
          </div>
          <div class="row"
            align="center">
            <div class="col-2"></div>
            <div class="col-8">
              <mat-card class="demo-inline-calendar-card calendar-width"
                style="margin-top: 10%">
                <mat-calendar [(selected)]="pauseDate"
                  (selectedChange)="dateTimeChange()"
                [minDate]="sharedMethodsService.getMinDate(currTrip)"></mat-calendar>
              </mat-card>
              @if (hasDuplicateDate) {
                <small i18n class="red-label">
            DFO has already confirmed a catch or pause report for this date. Only one catch or pause report per day is accepted, so this report will be returned as an error.
          </small>
              }
            </div>
          </div>
        </div>
      }
      <!-- Hiding national requirements
      <div *ngIf="currPage === 2" class="container details">
        <div class="row"
          align="center">
          <h5 i18n class="blue-heading-title">
            When was the end of the pause/inactivity?
          </h5>
        </div>
        <div class="row"
          align="center">
          <div class="col-2"></div>
          <div class="col-8">
            <mat-card class="demo-inline-calendar-card"
              style="margin-top: 10%">
              <mat-calendar [(selected)]="pauseEndDate"
                (selectedChange)="dateTimeChange()"
              [minDate]="sharedMethodsService.getMinDate(currTrip)"></mat-calendar>
            </mat-card>
          </div>
          <div class="outer">
            <div class="inner-2">
              <h6 i18n class="blue-label">
                Time (24hr): &nbsp;
              </h6>
            </div>
            <div class="inner-2">
              <ngb-timepicker ngDefaultControl class="time-picker"
                [spinners]="false"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="pauseEndTime"
              (ngModelChange)="dateTimeChange()"></ngb-timepicker>
            </div>
            <mat-error i18n *ngIf="!pauseEndTime"
              style="margin-left: 15px;">
              Required
            </mat-error>
          </div>
          <div class="col-2"></div>
        </div>
      </div>
      -->
      @if (currPage === 2) {
        <div class="container">
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
          Where did you intend to fish?
        </h5>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
          Management Area
        </h6>
            <mat-form-field appearance="fill">
              <mat-label i18n>
            Management Area
          </mat-label>
              <mat-select formControlName="managementArea" [compareWith]="compareArea">
                @for (area of sharedMethodsService.getManagementAreas(this.currTrip.licenseArea.licenseName, managementAreas); track area) {
                  <mat-option [value]="area">{{area}}</mat-option>
                }
              </mat-select>
              @if (pauseForm.invalid) {
                <mat-error i18n>
              [Required]
          </mat-error>
              }
            </mat-form-field>
          </div>
          <!-- Hiding national requirements
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
              What is your license number?
            </h5>
          </div>
          <div class="row">
            <mat-form-field appearance="fill">
              <mat-label i18n>
                License #
              </mat-label>
              <input matInput formControlName="licenseNum" maxlength="18">
              <mat-error i18n *ngIf="pauseForm.invalid">
                Required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
              What is the reason for the inactivity?
            </h5>
          </div>
          <div class="row">
            <mat-form-field appearance="fill">
              <mat-label i18n>
                Reason
              </mat-label>
              <textarea matInput
                maxlength="2000"
                formControlName="inactivityReason"
              rows="6"></textarea>
              <mat-error i18n *ngIf="pauseForm.invalid">
                Required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
              Do you have any comments specific to this inactivity?
            </h5>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
              Comments
            </h6>
            <mat-form-field appearance="fill">
              <mat-label i18n>
                Comments...
              </mat-label>
              <textarea matInput
                maxlength="2000"
                formControlName="reportDtlComment"
              rows="9"></textarea>
            </mat-form-field>
          </div>
          -->
        </div>
      }
      <!-- Comments -->
      @if (currPage === 3) {
        <div
          class="container">
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
          Would you like to add a comment?
        </h5>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
          Comments
        </h6>
            <mat-form-field appearance="fill">
              <mat-label i18n>
            Comments...
          </mat-label>
              <textarea matInput
                maxlength="300"
                formControlName="comments"
              rows="9"></textarea>
            </mat-form-field>
          </div>
        </div>
      }
      <!-- Summary page -->
      @if (currPage > numPages) {
        <div
          class="container details">
          @if (!isComplete) {
            <div class="row"
              align="center">
              <h5 i18n class="blue-heading-title">
          Is all information complete and ready to be submitted to DFO?
        </h5>
            </div>
          }
          @if (isComplete) {
            <div class="row">
              <h6 class="blue-label">
                <b i18n>
            Confirmation Number:
          </b>
                @if (pauseReport.confirmationNumber === 'Incomplete' ||
                  pauseReport.confirmationNumber === 'Not submitted' ||
                  pauseReport.confirmationNumber === 'Awaiting response') {
                  <span i18n>
            {pauseReport.confirmationNumber, select, Incomplete {Incomplete} Not submitted {Not submitted} Awaiting response {Awaiting response}}
          </span>
                } @else {
                  {{pauseReport.confirmationNumber}}
                }
              </h6>
            </div>
          }
          @if (this.pauseReport.confirmationNumber == 'Not submitted') {
            <div>
              <span i18n class="blue-label">
          Go to the records page to submit outstanding reports
        </span>
            </div>
          }
          @if (reportFailed) {
            <div class="row">
              <button mat-raised-button
                class="fishing-button-red"
                type="submit"
                (click)="reopenReport()"
                style="width: auto; text-align: left;">
                <span i18n>
            Reopen report
          </span>
              </button>
            </div>
          }
          <div class="row">
            <h6 i18n class="blue-label">
          <b>
            Pause Date:
          </b>
          {{ pauseDate | date }}
        </h6>
          </div>
          @if (hasDuplicateDate && !isComplete) {
            <div class="row">
              <small i18n class="red-label" (click)="navigateToPage(1)">
            DFO has already confirmed a catch or pause report for this date — this report will be returned as an error.
            <button mat-icon-button (click)="navigateToPage(1)">
              <mat-icon style="color: red;">edit</mat-icon>
            </button>
          </small>
            </div>
          }
          <!--
          <div class="row">
            <h6 i18n class="blue-label">
              <b>
                Pause End Date:
              </b>
              {{ pauseEndDate | date }} -- {{ pauseEndTime.hour }}:{{pauseEndTime.minute}}
            </h6>
          </div>
          -->
          <div class="row">
            <h6 i18n class="blue-label">
          <b>
            Management Area:
          </b>
          @if (mgmtAreaValid) {
<span>
            {{pauseForm.get('managementArea')?.value}}
          </span>
}
          @if (!mgmtAreaValid) {
<small class="red-label" (click)="navigateToPage(2)">
            [Required]
            <button mat-icon-button (click)="navigateToPage(2)">
              <mat-icon style="color: red;">edit</mat-icon>
            </button>
          </small>
}
        </h6>
          </div>
          <!--
          <div class="row">
            <h6 i18n class="blue-label">
              <b>
                License Number:
              </b>
              <span *ngIf="!pauseForm.get('licenseNum')?.errors?.required">
                {{pauseForm.get('licenseNum')?.value}}
              </span>
              <span *ngIf="pauseForm.get('licenseNum')?.errors?.required"
                class="invalid-field">
                [Required]
              </span>
            </h6>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
              <b>
                Reason for Inactivity:
              </b>
              <span *ngIf="!pauseForm.get('inactivityReason')?.errors?.required">
                {{pauseForm.get('inactivityReason')?.value}}
              </span>
              <span *ngIf="pauseForm.get('inactivityReason')?.errors?.required"
                class="invalid-field">
                [Required]
              </span>
            </h6>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
              <b>
                Report Detail Comments:
              </b>
              {{pauseForm.get('reportDtlComment')?.value}}
            </h6>
          </div>
          -->
          <div class="row">
            <h6 i18n class="blue-label">
          <b>
            Comments:
          </b>
          {{pauseForm.get('comments')?.value}}
        </h6>
          </div>
        </div>
      }
    </form>
    <!-- Buttons to navigate between pages -->
    @if (!isComplete) {
      <div class="row bottom-buttons">
        <div class="col-1"></div>
        <div class="col-4">
          <div class="row">
            <button mat-raised-button
              class="fishing-button-blue"
              type="button"
              (click)="toPreviousPage()">
              <span i18n>
            Back
          </span>
            </button>
          </div>
        </div>
        <div class="col-2"></div>
        <div class="col-4">
          <div class="row">
            <button mat-raised-button
              class="fishing-button-red"
              type="submit"
              (click)="toNextPage()">
              @if (currPage <= numPages) {
                <span i18n>
            Next
          </span>
              }
              @if (currPage > numPages) {
                <span i18n>
           Submit
          </span>
              }
            </button>
          </div>
        </div>
        <div class="col-1"></div>
      </div>
    }
    @if (isComplete) {
      <div class="row bottom-buttons" style="display: flex; justify-content: center;">
        <div class="col-4">
          <div class="row" style="display: flex; justify-content: center;">
            <button mat-raised-button
              class="fishing-button-blue"
              type="button"
              (click)="toPreviousPage()">
              <span i18n>
            Back
          </span>
            </button>
          </div>
        </div>
      </div>
    }
  </div>
}
